package tables.category

import categoryToJsonString
import emotion.react.css
import entities.Category
import kotlinx.browser.window
import models.CategoryModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface UpdateCategoryProps : Props {
    var categoryModel: CategoryModel?
    var listCategoryModel: List<CategoryModel>
    var onClose: () -> Unit
    var onUpdate: () -> Unit

}

val UpdateCategoryModal = FC<UpdateCategoryProps> { props ->
    if (props.categoryModel != null) {
        var categoryName by useState(props.categoryModel?.name ?: "")
        var iscategory by useState(props.categoryModel?.iscategory ?: false)
        var isactive by useState(props.categoryModel?.isactive ?: false)
        var status by useState("")
        var parentId by useState(props.listCategoryModel.filter { it.parent == props.categoryModel!!.parent }
            .first().id - 1)

        val (categories, setCategories) = useState(emptyList<CategoryModel>())

        fun loadCategories() {
            window.fetch(urlAddress + "api/category", RequestInit(
                method = "GET",
                headers = Headers().apply {
                    append("Authorization", "Bearer $token")
                }
            ))
                .then { response -> response.json() }
                .then { data ->
                    val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                        CategoryModel(
                            it.id as? Int ?: 0,
                            it.name as? String ?: "",
                            it.parent as? String ?: "",
                            it.iscategory as? Boolean ?: true,
                            it.isactive as? Boolean ?: true,

                            )
                    }
                    setCategories(newResultList)
                }
        }

        useEffect(categories.isEmpty()) {
            loadCategories()
        }

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Наименование:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = categoryName
                    type = InputType.text
                    onChange = { event ->
                        categoryName = event.target.value
                    }
                }
                p {
                    +"Категория:"
                }
                div {
                    select {
                        value = parentId
                        option {
                            value = 0
                            +"Главная"
                        }
                        props.listCategoryModel.forEach {
                            if (it.id != props.categoryModel!!.id) {
                                option {
                                    value = it.id
                                    +it.name
                                }
                            }
                        }
                        onChange = {
                            parentId = it.target.value.toInt()
                        }
                    }
                }
                p {
                    +"Является категорией:"
                }
                div {
                    input {
                        type = InputType.checkbox
                        checked = iscategory
                        onChange = {
                            iscategory = it.target.checked
                        }
                    }
                }
                p {
                    +"Активная:"
                }
                div {
                    input {
                        type = InputType.checkbox
                        checked = isactive
                        onChange = {
                            isactive = it.target.checked
                        }
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        +"Сохранить"
                        val category = Category(props.categoryModel!!.id, categoryName, parentId, iscategory, isactive)
                        onClick = {
                            window.fetch(
                                urlAddress + "api/category", RequestInit(
                                    method = "PUT",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = categoryToJsonString(category)
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        status = "Ошибка"
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

